import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import BusinessIcon from '@material-ui/icons/Business'
import CategoryIcon from '@material-ui/icons/Category'
import MenuBookIcon from '@material-ui/icons/MenuBook'
import SettingsIcon from '@material-ui/icons/Settings'

import React, { FC } from 'react'
import styled from 'styled-components'

import ListItemLink from '../components/listItemLink'

const Wrapper = styled.div`
  height: inherit;
  width: inherit;
  display: flex;
  justify-content: center;
  border-right: 1px solid rgba(0, 0, 0, 0.09);
`

const StyledList = styled(List)`
  padding: 0px !important;
`

const LogoListItem = styled(ListItem)`
  height: 7%;
  width: 100%;
`

const StyledListItemLink = styled(ListItemLink)`
  margin: 15px 0px 15px 0px;
`

const SideMenu: FC = () => {
  return (
    <Wrapper>
      <StyledList>
        <LogoListItem button style={{ justifyContent: 'center' }}>
          <img
            alt="Fruit Supplier Logo"
            src="/fruit-supplier-logo.png"
            width="50px"
            height="40px"
          />
        </LogoListItem>
        <Divider />
        <StyledListItemLink href="/company">
          <ListItemIcon>
            <BusinessIcon />
          </ListItemIcon>
          <ListItemText primary={'Profiles'} />
        </StyledListItemLink>
        <StyledListItemLink href="/category">
          <ListItemIcon>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText primary={'Category'} />
        </StyledListItemLink>
        <StyledListItemLink href="/blog">
          <ListItemIcon>
            <MenuBookIcon />
          </ListItemIcon>
          <ListItemText primary={'Blog'} />
        </StyledListItemLink>
        <StyledListItemLink href="/setting">
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary={'Setting'} />
        </StyledListItemLink>
      </StyledList>
    </Wrapper>
  )
}

export default SideMenu
